<template>
  <div class="game-search-skeleton">
    <SkeletonBlock width="98%" height="44px" :rounded="false" />
    <div class="button-row">
      <SkeletonBlock v-for="button in 5" :key="button" width="88px" height="30px" />
    </div>
    <div class="list">
      <div v-for="item in 6" :key="item" class="list-item">
        <div class="list-copy">
          <SkeletonBlock width="70%" height="18px" />
          <SkeletonBlock width="46%" height="14px" />
        </div>
        <SkeletonBlock width="55px" height="55px" :rounded="false" />
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonBlock from "./SkeletonBlock.vue";

export default {
  name: "GameSearchSkeleton",
  components: {
    SkeletonBlock,
  },
};
</script>

<style scoped>
.game-search-skeleton {
  padding: 20px 0 0;
}

.button-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.list {
  margin-top: 20px;
}

.list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 12px 8px;
  border-bottom: 1px solid #eef2f6;
}

.list-copy {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
}

@media (max-width: 600px) {
  .button-row {
    flex-direction: column;
  }
}
</style>
